exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".login-container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    width: 100%;\n    height: 100%;\n    background-color: #dcdcdc;\n    padding: 2rem;\n}\n\n.login-container .error {\n  color: #ff4136;\n  margin-bottom: 1rem;\n  display: block;\n}\n\n.login-form {\n  width: 100%;\n  max-width: 320px;\n  background-color: #fff;\n  padding: 2rem;\n  border-radius: 5px;\n  position: absolute;\n  -webkit-transform: translate(-50%,-50%);\n          transform: translate(-50%,-50%);\n  top: 50%;\n  left: 50%;\n}\n\n.login-form .btn {\n  width: 100%;\n  margin-top: 1rem;\n}\n\n.login-cool {\n  width: 64px;\n  height: 64px;\n  display: block;\n  margin: 0 auto 2rem auto;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.css
// module id = 420
// module chunks = 1